// @flow
import * as React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
  children?: React.Node,
}

const InlineList = ({ className, children }: PropsT) => (
  <ul className={classnames('InlineList', className)} >
    {children && React.Children.map(children, child => (
      <li>
        {child}
      </li>
    ))}
  </ul>
)

export default InlineList
